/*
 * AppDrawerConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */

enum ActionTypes {
  CHANGE_APP_DRAWER_VISIBILITY = 'CHANGE_APP_DRAWER_VISIBILITY',
  CHANGE_USER_IN_SESSION = 'CHANGE_USER_IN_SESSION',
  CHANGE_USER_NAME = 'CHANGE_USER_NAME',
  CHANGE_REDIRECT_URL = 'CHANGE_REDIRECT_URL',
}

export default ActionTypes;
